import { render, staticRenderFns } from "./iplVipLayout.vue?vue&type=template&id=fae6ce34&"
import script from "./iplVipLayout.vue?vue&type=script&lang=js&"
export * from "./iplVipLayout.vue?vue&type=script&lang=js&"
import style0 from "./iplVipLayout.vue?vue&type=style&index=0&id=fae6ce34&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports